import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { NotificationResponseDto } from '../../../commonTypes/NotificationTypes/notification.types';
import { selectNotifications, setNotifications } from '../../../store/slices/notification-center.slice';

const useHttpGetNotificationsByUserOnMount = () => {
    const dispatch = useDispatch();
    const userApi = useContainer(UserApi);
    const [isReady, setReady] = useState(false);
    const notifications = useSelector(selectNotifications);

    const fetchNotifications = () => {
        userApi
            .getNotificationsByUser({
                onSuccess: res => {
                    const notificationData: NotificationResponseDto = Array.isArray(res.body)
                        ? {
                              items: res.body,
                              total: res.body.length,
                          }
                        : res.body && 'items' in res.body
                        ? res.body
                        : {
                              items: [],
                              total: 0,
                          };

                    dispatch(setNotifications(notificationData));
                },
                onError: _ => {
                    dispatch(setNotifications({ items: [], total: 0 }));
                },
                onFinally: () => {
                    setReady(true);
                },
            })
            .exec();
    };

    useEffect(() => {
        fetchNotifications();
        return () => userApi.getNotificationsByUser({}).abort();
    }, []);

    return { data: notifications, isReady };
};

export default useHttpGetNotificationsByUserOnMount;
